import React from 'react';
import DocumentsPageTotalPages from './components/additional-informative-components/DocumentsPageTotalPages';
import RecipientsTotalNumber from './components/additional-informative-components/RecipientsTotalNumber';

interface AdditionalInformationProps {
  currentIndex: number;
}

const AdditionalInformation: React.FC<AdditionalInformationProps> = ({
  currentIndex,
}) => {
  const additionalInformationMapper: { [key: number]: JSX.Element } = {
    1: <DocumentsPageTotalPages />,
    2: <RecipientsTotalNumber />,
  };

  return <div>{additionalInformationMapper[currentIndex]}</div>;
};

export default AdditionalInformation;
